<div class="page-not-found-container">
    <div class="title">Page Not Found</div>
    <div class="subtitle">You seem to have reached this page by mistake. Click the button below to return to the dashboard.</div>
    <button class="save save-button" (click)="returnToDashboard()">Return To Dashboard</button>
</div>
